import React from 'react';

import FormElement from 'Components/Core/Form/FormElement';
import ModuleTable from 'Components/Core/ModuleTable';
import './MemberList.css';

export default function MemberListBasis(props) {

	const x = props.x;

	/*
	const [error, setError] = React.useState(false);
	const [message, setMessage] = React.useState('');

	function onAfterSend(result) {
		if (result.returncode === 1) {
			x.wah.addHint('Benutzer angelegt...');
			setError(false);
			setMessage(<div>Benuter angelegt.<br/> <div>{'Temporäres Kennwort: '}<br/> {result.content.password} </div></div> );
			x.wab['member-listing'].reload();
		}
		else {
			setError(true);
		}
	}
	*/

	return (
		<ModuleTable
			id={props.id}
			tableId="sectionId"
			x={x}
			classes={`module-member-list `}
			tableClasses={`member-list `}
			title={props.title}
			addTitle="Neues Mitglied anlegen"
			module="Member"
			listTask="MemberList"
			formFields = {
				<>
					<FormElement x={x}   wafId={props.id} id="member-name" title="Pseudonym"  />
				</>
			}
			focusField="member-name"
			formSendTask="AddMember"									
			onAddHeader={(addHeader) => {
				addHeader('ID');
				addHeader('Pseudonym');
				addHeader('Letzte Anmeldung');
				addHeader('Letzter Zugriff');
				addHeader('Gesperrt');
				addHeader('Beiträge');
			}}
			onAddColumn={(key, value) => {  
				switch (key) {
					case 'memberid':
					case 'membername':
					case 'lastlogin':
					case 'lastrequest':
					case 'postingcount':
					case 'locked':
						return value;
					default:
						return false;
				}
			}}
			onEditRow={(e, rowFields, rowId) => {
				e.preventDefault();
				x.wam.openPrivateForum(rowFields.memberid, rowFields.membername, rowFields.memberlevel);
			}}
		/>
	)
};

